export enum GraphQLErrorCode {
	UNI_COURSES_404 = 'UNIVERSITY_COURSES_NOT_FOUND',
	UNI_CLEARING_COURSES_404 = 'CLEARING_UNIVERSITY_COURSE_NOT_FOUND',
	UNI_404 = 'UNIVERSITY_NOT_FOUND',
	UNI_SECTION_404 = 'UNIVERSITY_PROFILE_NOT_FOUND',
	CLEARING_UNI_404 = 'CLEARING_UNIVERSITY_NOT_FOUND',
}
